import React, { Component } from 'react';
import axios from "axios";
import {TextField, Autocomplete, Drawer, Paper, FormControl, InputLabel, Grid, Container, Button, Table, IconButton, TableHead, TableRow, TableCell, TableBody, Box, Typography, Chip, Avatar, Tooltip, Divider, Dialog, DialogContent, DialogActions, DialogContentText} from '@mui/material';
import Api from "../../customlib/Api";
import { FormControlLabel, MenuItem, Select, Switch } from '@mui/material';
import './SettingContact.css';
import Global from '../../customlib/Global';
import { Add, Delete, Edit, PersonOutline, Groups, WarningAmberRounded, DeleteForever } from '@mui/icons-material';

class SalesManagement extends Component {

    constructor(props) {
      super(props);
      this.state = {
        item: this.emptyCustomer,
        sales: []
      };
      // this.handleChange = this.handleChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
    }
  
    state = { 
        contacts : [],
        sales : [],
        contactSelectedToUpdate: [],
        checkAll : null,
        salesData: [],
        selectedSales : {},//id = id, lavenderSalesId, lavenderSalesName, salesType
        id: 0,
        lavenderSalesId: 0,
        lavenderSalesName: "",
        salesType: "Acquisition",
        checkpointCount: 24,
        bottom: false,
        salesInfo: {}, //id = id, lavenderSalesId, lavenderSalesName, salesType
        showDeleteSalesLavenderDialog: false,
        idDelete:0,
        idSalesDelete:0,
        nameSalesDelete:"",
        allowReceiveLeads: 1,
        isNightShift: false
    }

   
    
    componentDidMount() {
        this.getSaleses();
        this.getSalesTeleUsers();
        this.setState({id: 0});
        
    }

    getSalesTeleUsers = () => {
        axios
        .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeaderJsonNew())
        .then((response) => {
            console.log("SALESTELEUSER : ", response.data.data);
            this.setState({salesData: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };

    getSaleses = () => {
      axios
        .post(Api.getSalesChatList(), {appProfileId: Global.getAppProfile()._id}, Api.getRequestHeaderJsonNew())
        .then((response) => {
            console.log("SALESCHATLIST : ", response.data.data);
            this.setState({sales: response.data.data});
        })
        .catch((error) => {
            console.error("There was an error!", error);
        });
    };


    handleAddButton = () => {
        let newData = 
        {
            id: 0,
            lavenderSalesId: 0,
            lavenderSalesName: "",
            salesType: "Acquisition",
            checkpointCount: 24
        };

        const sales = [...this.state.contacts, newData];

        this.setState({contacts: []}, ()=>{
            this.setState({contacts: sales});
        });

    }

    handleSalesTypeChange = (event) => {
      this.setState({
          salesType: event.target.value
      });
    };

    handleCheckpointCountChange = (event) => {
      this.setState({
          checkpointCount: event.target.value
      });
    };

    handleSelectionChanged = (salesName) => {
      const salesData = [...this.state.salesData];
      // console.log("SALESDATA : ", salesData);
      let selected = salesData.filter((sales) => sales.name===salesName);
      console.log("FINDSELECTION : ", selected);

      if(selected.length > 0){
          let newData = JSON.parse(JSON.stringify(selected[0]));
          
          newData.lavenderSalesId = selected.id;
 
          this.setState({
            selectedSales: newData,
            lavenderSalesId: selected[0].id,
            lavenderSalesName: selected[0].name,
          });
          console.log(selected[0].id);
          console.log(selected[0].name);
          

          // console.log(this.state.lavenderSalesId );
          // console.log(this.state.lavenderSalesName);
      }

  }

  editSales = (id, salesId, salesName, salesType, allowReceiveLeads, isNightShift) => {
    // this.state.id = id;
    // this.state.lavenderSalesId = salesId;
    // this.state.lavenderSalesName = salesName;
    // this.state.salesType = salesType;
    // this.state.allowReceiveLeads = allowReceiveLeads;

    // console.log(this.state.id);
    // console.log(this.state.lavenderSalesId );
    // console.log(this.state.lavenderSalesName);
    // console.log(this.state.salesType);

    this.setState({ id: id, lavenderSalesId: salesId, lavenderSalesName: salesName, salesType: salesType, allowReceiveLeads: allowReceiveLeads, isNightShift: isNightShift, bottom: true });
    
  }

  addSales = () => {
    this.setState({ id: 0, lavenderSalesId: 0, lavenderSalesName: "", salesType: "Acquisition", allowReceiveLeads: 1, bottom: true });
  }


  cancel(){
    this.setState({ ...this.state, 'bottom': false });
  }

  async handleSubmit(event) {
    event.preventDefault();
      
    if(this.state.id === ''){
      this.state.id = '0';
    }else{
      // this.state.id = '0';
    }

    // console.log("id--> "+this.state.id);
    // console.log("selectedSales--> "+this.state.lavenderSalesId);
    // console.log("selectedSalesname--> "+this.state.lavenderSalesName);
    // console.log("salesType--> "+this.state.salesType);
    // console.log("appProfileId--> ", Global.getAppProfile()._id);
    
    var params = [
      {
        id: this.state.id, 
        lavenderSalesId: this.state.lavenderSalesId, 
        lavenderSalesName: this.state.lavenderSalesName, 
        salesType: this.state.salesType, 
        allowReceiveLeads: this.state.allowReceiveLeads,
        appProfileId: Global.getAppProfile()._id,
        isNightShift: this.state.isNightShift
      }
    ];

    console.log("PARAMS_SAVE_SALES", params);

    axios
      .post(Api.doSaveSales(), params, 
        Api.getRequestHeader())
      .then((response) => {
        console.log("doSaveSales : ", response.data);
        let responseData = response.data;
        if(responseData.success){
            console.log(responseData);
            // this.props.history.push('/setting');
            this.getSaleses();
            // return;
            
            this.setState({ ...this.state, 'bottom': false });
        }
        // this.setState({contacts: response.data.data});
        
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  handleRemoveSales = () => {
      console.log(this.state.idDelete);
      console.log(this.state.idSalesDelete);

    axios
    .post(Api.deleteSales(), {id: this.state.idDelete, lavenderSalesId: this.state.idSalesDelete}, Api.getRequestHeader())
    .then((response) => {
      console.log("doSaveSales : ", response.data);
      let responseData = response.data;
      if(responseData.success){
          console.log(responseData);
          this.getSaleses();
          this.handleCloseLogoutDialog();
      }
      
    })
    .catch((error) => {
      console.error("There was an error!", error);
    });
  }

  handleRemoveSalesDialog = (id, lavenderSalesId, lavenderSalesName) => {

    this.setState({ showDeleteSalesLavenderDialog: true,
                    idDelete: id,
                  idSalesDelete: lavenderSalesId,
                   nameSalesDelete: lavenderSalesName});


  }

  handleSwitchLeads = () => {
    let allowLeads = 0;
    if(this.state.allowReceiveLeads === 1){
      allowLeads = 0;
    }else{
      allowLeads = 1;
    }

    this.setState({allowReceiveLeads: allowLeads});

  }

  handleSwitchNightShift = () => {
    let isNightShift = false;
    if(this.state.isNightShift === true){
      isNightShift = false;
    }else{
      isNightShift = true;
    }

    this.setState({isNightShift: isNightShift});

  }

  handleCloseLogoutDialog = () => {
    this.setState({ showDeleteSalesLavenderDialog: false });
  };
    
    render() { 

      const { sales  } = this.state;

      const toggleDrawer = (anchor, open) => (event) => {
        
        // console.log('this.state.id=> '+this.state.id);
        // if(this.state.id === 0){
        //   // this.setState({
        //     this.state.salesType = 'Acquisition';
        //     this.state.allowReceiveLeads = 1;
        //     // }); 
        // }

        // if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        //   return;
        // }

         
        // if(open === false){
          
        //   this.state.id = 0;
        //   this.state.lavenderSalesName = '';
        //   // if(this.state.salesType === ''){
        //     // this.state.salesType = 'Acquisition';
        //   // }else{
        //     this.state.salesType = '';
        //   // }

        //   // this.setState({ id: 0, lavenderSalesName: "", salesType: "", [anchor]: open });

        // }else{
        //   if(open === true && this.state.id === ''){
        //     // this.setState({
        //       this.state.salesType = 'Acquisition';
        //       // [anchor]: open
        //       // }); 
        //   }
        // }

      
        this.setState({[anchor]: open });
      };
 

        return (
          <Box sx={{ p: 0 }}>
            <Dialog
              open={this.state.showDeleteSalesLavenderDialog}
              onClose={this.handleCloseLogoutDialog}
              PaperProps={{ sx: { borderRadius: "14px", width: 380 } }}
            >
              <DialogContent sx={{ textAlign: "center", pt: 4, pb: 1 }}>
                <Box
                  sx={{
                    width: 64,
                    height: 64,
                    borderRadius: "50%",
                    bgcolor: "#fdecea",
                    color: "error.main",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mx: "auto",
                    mb: 2,
                  }}
                >
                  <WarningAmberRounded sx={{ fontSize: 34 }} />
                </Box>
                <Typography variant="h6" fontWeight={700}>Hapus Sales Ini?</Typography>
                <DialogContentText sx={{ mt: 1 }}>
                  Anda akan menghapus <strong>{this.state.nameSalesDelete}</strong> dari daftar sales. Tindakan ini tidak dapat dibatalkan.
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
                <Button
                  onClick={this.handleCloseLogoutDialog}
                  fullWidth
                  variant="contained"
                  sx={{ textTransform: "none", borderRadius: "8px" }}
                >
                  Batalkan
                </Button>
                <Button
                  onClick={this.handleRemoveSales}
                  fullWidth
                  color="error"
                  variant="outlined"
                  startIcon={<DeleteForever />}
                  sx={{ textTransform: "none", borderRadius: "8px" }}
                >
                  Ya, Hapus
                </Button>
              </DialogActions>
            </Dialog>

            <Drawer
              anchor={'right'}
              open={this.state['bottom']}
              onClose={toggleDrawer('bottom', false)}
              PaperProps={{ sx: { width: { xs: '100%', sm: 420 } } }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, bgcolor: "primary.main", color: "#fff", px: 3, py: 2 }}>
                <PersonOutline />
                <Typography variant="h6" fontWeight={700}>
                  {this.state.id ? "Edit Salesman" : "Input Salesman"}
                </Typography>
              </Box>
              <Container sx={{ py: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                      {(this.state.salesData && this.state.salesData.length > 0) ?
                          <Autocomplete
                              id="free-solo-2-demo"
                              freeSolo
                              options={this.state.salesData.map((option) => {
                                  return String(option.name);
                              })}
                              onChange={(event, newValue) => {
                                  this.handleSelectionChanged(newValue);
                              }}
                              value={this.state.lavenderSalesName}
                              renderInput={(params) => (
                              <TextField
                                  {...params}
                                  label="Nama Sales"
                                  variant="outlined"
                                  InputProps={{ ...params.InputProps, type: 'search' }}
                                  size='small'
                              />
                              )}
                              size='small'
                          />
                      :
                      <></>
                      }
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControl fullWidth size='small'>
                      <InputLabel id="sales_type_cb_labelid">Tipe Sales</InputLabel>
                      <Select
                          labelId="sales_type_cb_labelid"
                          id="sales_type_cb"
                          value={this.state.salesType}
                          onChange={this.handleSalesTypeChange}
                          label="Tipe Sales"
                          size='small'
                          fullWidth>
                          <MenuItem value={"Acquisition"}>Acquisition</MenuItem>
                          <MenuItem value={"Retention"}>Retention</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Box sx={{ bgcolor: "#f5f5f5", borderRadius: "8px", p: 1.5 }}>
                      <Grid container spacing={1}>
                        <Grid item xs={6}>
                          <FormControlLabel
                            label= {this.state.allowReceiveLeads === 1 ? "Auto Leads (ON)" : "Auto Leads (OFF)"}
                            control={
                              <Switch
                                checked={this.state.allowReceiveLeads === 1}
                                onChange={this.handleSwitchLeads}
                                name="switchLeads"
                                size='small'
                              />
                            }
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <FormControlLabel
                            label= {this.state.isNightShift === true ? "Night Shift (ON)" : "Night Shift (OFF)"}
                            control={
                              <Switch
                                checked={this.state.isNightShift === true}
                                onChange={this.handleSwitchNightShift}
                                name="switchNightShift"
                                size='small'
                              />
                            }
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Button variant='contained' fullWidth color="primary" onClick={this.handleSubmit} sx={{ textTransform: "none" }}>Save</Button>
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant='outlined' fullWidth onClick={() => this.cancel()} sx={{ textTransform: "none" }}>Cancel</Button>
                        </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Container>
            </Drawer>

            <Paper variant="outlined" sx={{ borderRadius: "10px", p: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                  <Groups sx={{ fontSize: 26, color: "primary.main" }} />
                  <Box>
                    <Typography variant="subtitle1" fontWeight={700}>Sales List</Typography>
                    <Typography variant="caption" color="text.secondary">{sales.length} sales terdaftar</Typography>
                  </Box>
                </Box>
                <Button variant='contained' color="success" startIcon={<Add />} sx={{ textTransform: "none", borderRadius: "8px" }} onClick={this.addSales}>
                  Add Sales
                </Button>
              </Box>

              <Table size='small'>
                <TableHead>
                  <TableRow sx={{ "& th": { fontWeight: 700, bgcolor: "#f5f5f5" } }}>
                    <TableCell width="25%">Sales Name</TableCell>
                    <TableCell width="20%">Sales Type</TableCell>
                    <TableCell width="15%">Auto Leads</TableCell>
                    <TableCell width="15%">Night Shift</TableCell>
                    <TableCell width="15%" align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {sales.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={5} align="center">
                          <Typography variant="body2" color="text.secondary" sx={{ py: 3 }}>Belum ada data sales.</Typography>
                        </TableCell>
                      </TableRow>
                    )}
                    {
                      sales.map(saless => {
                        return <TableRow key={saless.id} hover>
                            <TableCell style={{whiteSpace: 'nowrap'}}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Avatar sx={{ width: 28, height: 28, fontSize: "0.8rem", bgcolor: "primary.main" }}>
                                  {saless.lavenderSalesName?.charAt(0)?.toUpperCase() || "?"}
                                </Avatar>
                                {saless.lavenderSalesName}
                              </Box>
                            </TableCell>
                            <TableCell style={{whiteSpace: 'nowrap'}}>{saless.salesType}</TableCell>
                            <TableCell style={{whiteSpace: 'nowrap'}}>
                              <Chip
                                label={saless.allowReceiveLeads === 1 ? "ON" : "OFF"}
                                color={saless.allowReceiveLeads === 1 ? "success" : "default"}
                                size="small"
                                sx={{ fontWeight: 600 }}
                              />
                            </TableCell>
                            <TableCell style={{whiteSpace: 'nowrap'}}>
                              <Chip
                                label={saless.isNightShift === true ? "YES" : "NO"}
                                color={saless.isNightShift === true ? "info" : "default"}
                                size="small"
                                sx={{ fontWeight: 600 }}
                              />
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title="Edit">
                                <IconButton
                                  size='small'
                                  onClick={ () => this.editSales(saless.id, saless.lavenderSalesId, saless.lavenderSalesName, saless.salesType, saless.allowReceiveLeads, saless.isNightShift)}
                                  color='primary'>
                                    <Edit fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Hapus">
                                <IconButton
                                  size="small"
                                  color="error"
                                  onClick={() => this.handleRemoveSalesDialog(saless.id, saless.lavenderSalesId, saless.lavenderSalesName)}>
                                    <Delete fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                    })
                    }
                </TableBody>
              </Table>
            </Paper>
          </Box>
        );

    }
}

export default SalesManagement;
